import { SERVER_URL } from "../../../constants";
import { fetchJson } from "../utils/http";

export const getGroupPayments = (groupId, token) =>
  fetchJson(`${SERVER_URL}api/campgroup/${groupId}/group-payments`, token);

export const createGroupPayment = (groupId, payload, token) =>
  fetchJson(`${SERVER_URL}api/campgroup/${groupId}/group-payments`, token, {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const updateGroupPayment = (groupId, paymentId, payload, token) =>
  fetchJson(
    `${SERVER_URL}api/campgroup/${groupId}/group-payments/${paymentId}`,
    token,
    {
      method: "PUT",
      body: JSON.stringify(payload),
    }
  );

export const deleteGroupPayment = (groupId, paymentId, token) =>
  fetchJson(
    `${SERVER_URL}api/campgroup/${groupId}/group-payments/${paymentId}`,
    token,
    { method: "DELETE" }
  );

export const getGroupInvoice = (groupId, token) =>
  fetchJson(`${SERVER_URL}api/campgroup/${groupId}/invoice`, token);
